import { render } from "./InvitationWidget.vue?vue&type=template&id=7da99050&scoped=true"
import script from "./InvitationWidget.vue?vue&type=script&lang=js"
export * from "./InvitationWidget.vue?vue&type=script&lang=js"

import "./InvitationWidget.vue?vue&type=style&index=0&id=7da99050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da99050"]])

export default __exports__